import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';
import { emailTemplatesActions } from '@/Pages/Settings/modules/EmailTemplatesSettings/services/reducer';
import { useDispatch } from 'react-redux';

export function useEmailTemplateSettings() {
  const dispatch = useDispatch();

  const {
    tours: {
      EmailTemplateSettings: { Default, Template },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: Default.Title,
      steps: [
        {
          content: Default.Step1.Text,
          placement: 'auto',
          target: '#templateTitle',
          title: Default.Step1.Title,
          disableBeacon: true,
          link: Default.Step1.DetailsLink,
        },
        {
          content: Default.Step2.Text,
          placement: 'auto',
          target: '#templatesTable',
          title: Default.Step2.Title,
          disableBeacon: true,
          link: Default.Step2.DetailsLink,
        },
        {
          content: Default.Step3.Text,
          placement: 'auto',
          target: '#crudExtended',
          title: Default.Step3.Title,
          disableBeacon: true,
          link: Default.Step3.DetailsLink,
        },
        {
          content: Default.Step4.Text,
          placement: 'auto',
          target: '.dx-toolbar-after',
          title: Default.Step4.Title,
          disableBeacon: true,
          link: Default.Step4.DetailsLink,
          spotlightPadding: 0,
          styles: {
            spotlight: {
              maxWidth: '500px',
            },
          },
        },
        {
          content: Default.Step5.Text,
          placement: 'auto',
          target: '#tableImportButton',
          title: Default.Step5.Title,
          disableBeacon: true,
          link: Default.Step5.DetailsLink,
          styles: {
            spotlight: {
              minWidth: '65px',
            },
          },
        },
      ],
    }),
    [Default],
  );

  const templateTour = useMemo<TourType>(
    () => ({
      id: 'templateTour',
      title: Template.Title,
      before: () => {
        dispatch(emailTemplatesActions.setModalData({ visible: true }));
      },
      steps: [
        {
          content: Template.Step1.Text,
          placement: 'auto',
          target: '#templateName',
          title: Template.Step1.Title,
          disableBeacon: true,
          link: Template.Step1.DetailsLink,
        },
        {
          content: Template.Step2.Text,
          placement: 'auto',
          target: '#emailData',
          title: Template.Step2.Title,
          disableBeacon: true,
          link: Template.Step2.DetailsLink,
        },
        {
          content: Template.Step3.Text,
          placement: 'auto',
          target: '#sendingEmail',
          title: Template.Step3.Title,
          disableBeacon: true,
          link: Template.Step3.DetailsLink,
        },
        {
          content: Template.Step4.Text,
          placement: 'auto',
          target: '#attachFiles',
          title: Template.Step4.Title,
          disableBeacon: true,
          link: Template.Step4.DetailsLink,
        },
        {
          content: Template.Step5.Text,
          placement: 'auto',
          target: '#compartment',
          title: Template.Step5.Title,
          disableBeacon: true,
          link: Template.Step5.DetailsLink,
        },
        {
          content: Template.Step6.Text,
          placement: 'auto',
          target: '#templateAutomation',
          title: Template.Step6.Title,
          disableBeacon: true,
          link: Template.Step6.DetailsLink,
        },
        {
          content: Template.Step7.Text,
          placement: 'left',
          target: '#dxReportDesignerId',
          title: Template.Step7.Title,
          disableBeacon: true,
          link: Template.Step7.DetailsLink,
        },
      ],
    }),
    [Template],
  );

  return [pageTour, templateTour];
}
